import { CheckboxAttributeProps } from 'Types/Attribute.types'
import Checkbox from 'antd/lib/checkbox'
import React, { useCallback, useMemo } from 'react'
import './Checkbox.less'

const CheckboxGroup = Checkbox.Group

const CheckboxAttribute: React.FC<CheckboxAttributeProps> = props => {
    const checkAll = useMemo(
        () => props.options?.length === props.value?.length,
        [props.options, props.value]
    )

    const indeterminate = useMemo(
        () => (props.value?.length ?? 0) > 0 && (props.value?.length ?? 0) < props.options?.length,
        [props.options, props.value]
    )

    const onChange = useCallback(
        (list: string[]) => {
            props.onChange(list.length ? list : undefined)
        },
        [props]
    )

    const onCheckAllChange = useCallback(
        (e: { target: { checked: boolean } }) => {
            const newValue = e.target.checked ? props.options.map(o => o.value) : []
            onChange(newValue)
        },
        [onChange, props.options]
    )

    return (
        <div
            className={`attribute-main ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="checkbox-wrapper"
        >
            <span className="attribute-main-title">{props.label}</span>
            <Checkbox
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}
                data-testid="checkbox"
                disabled={props.readonly}
            >
                Check all
            </Checkbox>
            <CheckboxGroup
                options={props.options}
                value={props.value as string[]}
                onChange={onChange}
                disabled={props.readonly}
            />
        </div>
    )
}

export default CheckboxAttribute
